module.exports = __webpack_public_path__ + "img/Weapon_104.32d199f5.png";